/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import ErrorBoundary from 'base/components/ErrorBoundary';
import LabradorCheckbox from 'base/components/labrador/Checkbox';

export const DynamicLabradorCheckbox: typeof LabradorCheckbox = (props) => {
    return <ErrorBoundary><LabradorCheckbox {...props} /></ErrorBoundary>;
}
export type DynamicLabradorCheckboxProps = PropsFromComponent<typeof LabradorCheckbox>;
